export default "__VITE_ASSET__DRB3oVkc__"